'use strict';

export default class Cart {
  constructor () {
    this.products = [];
    this.qtd = 0;
    this.subtotal = 0;
    this.show = false;
  }
};



// WEBPACK FOOTER //
// ./src/models/class/cart-class.js